export const OKTA_EXTERNAL_CONFIG = {
  issuer: `${process.env.REACT_APP_EXTERNAL_ISSUER}`,
  clientId: `${process.env.REACT_APP_EXTERNAL_CLIENT_ID}`,
  redirectUri: `${process.env.REACT_APP_OKTA_REDIRECT_URL}`,
  scopes: ["openid", "profile", "email", "offline_access"],
  pkce: true,
};

export const OKTA_INTERNAL_CONFIG = {
  issuer: `${process.env.REACT_APP_INTERNAL_ISSUER}`,
  clientId: `${process.env.REACT_APP_INTERNAL_CLIENT_ID}`,
  redirectUri: `${process.env.REACT_APP_OKTA_REDIRECT_URL}`,
  scopes: ["openid", "profile", "email", "offline_access"],
  pkce: true,
};
